"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.whereClause = exports.conditionClauses = exports.fieldMatchesPrefix = exports.fieldIsGreaterThanOrEqualTo = exports.fieldIsLessThanOrEqualTo = exports.fieldIsGreaterThan = exports.fieldIsLessThan = exports.fieldMatchesAny = exports.fieldMatches = void 0;
/**
 * Creates a closure which generates a clause to check if a field in a given table mathces a queried value.
 * @param field name of the column in the table which should be compared.
 */
function fieldMatches(field) {
    return (tableName) => `${tableName}.${field} = \${${tableName}.${field}}`;
}
exports.fieldMatches = fieldMatches;
/**
 * Creates a closure which generates a clause to check if a field in a given table mathces an entry in a
 * queried value array.
 * @param field name of the column in the table which should be compared.
 */
function fieldMatchesAny(field) {
    return (tableName) => `${tableName}.${field} = ANY(\${${tableName}.${field}})`;
}
exports.fieldMatchesAny = fieldMatchesAny;
/**
 * Creates a closure which generates a clause to check if a field in a given table is less than a queried value.
 * @param field name of the column in the table which should be compared.
 */
function fieldIsLessThan(field) {
    return (tableName) => `\${${tableName}.${field}} < ${tableName}.${field}`;
}
exports.fieldIsLessThan = fieldIsLessThan;
/**
 * Creates a closure which generates a clause to check if a field in a given table is greater than a queried value.
 * @param field name of the column in the table which should be compared.
 */
function fieldIsGreaterThan(field) {
    return (tableName) => `\${${tableName}.${field}} > ${tableName}.${field}`;
}
exports.fieldIsGreaterThan = fieldIsGreaterThan;
/**
 * Creates a closure which generates a clause to check if a field in a given table is less than or equal to a
 * queried value.
 * @param field name of the column in the table which should be compared.
 */
function fieldIsLessThanOrEqualTo(field) {
    return (tableName) => `\${${tableName}.${field}} <= ${tableName}.${field}`;
}
exports.fieldIsLessThanOrEqualTo = fieldIsLessThanOrEqualTo;
/**
 * Creates a closure which generates a clause to check if a field in a given table is greater than or equal to a
 * queried value.
 * @param field name of the column in the table which should be compared.
 */
function fieldIsGreaterThanOrEqualTo(field) {
    return (tableName) => `\${${tableName}.${field}} >= ${tableName}.${field}`;
}
exports.fieldIsGreaterThanOrEqualTo = fieldIsGreaterThanOrEqualTo;
/**
 * Creates a closure which generates a clause to check if a text field in a given table begins with a queried value.
 * @param field name of the column in the table which should be compared.
 */
function fieldMatchesPrefix(field) {
    return (tableName) => `\${${tableName}.${field}} ILIKE ${tableName}.${field} || '%%'`;
}
exports.fieldMatchesPrefix = fieldMatchesPrefix;
/**
 * Generates an array of clauses for use in a where clause to filter rows from a given table according to a given
 * set of parameters.
 * @param parameters a map of parameter names to values.
 * @param map a map of parameter names to functions for generating corresponding where clauses for a given table.
 * @param tableName the table on which to exeute the query.
 */
function conditionClauses(parameters, map, tableName) {
    return Object.keys(parameters).filter((key) => parameters[key] !== undefined && map.has(key)).map(key => map.get(key)(tableName, parameters));
}
exports.conditionClauses = conditionClauses;
/**
 * Generates a where clause from a list of conditions; conditions are joined by the AND operator.
 * @param conditions the list of conditions to check.
 */
function whereClause(conditions) {
    return conditions.length ? conditions.map((x) => `(${x})`).join(" AND ") : "TRUE";
}
exports.whereClause = whereClause;
